
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'DescriptionItem'
})
export default class DescriptionItem extends Vue {
  @Prop() name!: string
  @Prop() description!: string[]
}
